import { useState, useCallback } from 'react';
import { useSeoFetch } from '@/hooks/useSeoFetch';
import useSeoProject from '@/hooks/useSeoProject';
import seoChangelogService from '@/services/seoChangelog';
import { SeoChangelog } from '@/types/api/seo';
import SeoChangelogComponent from './SeoChangelog.component';

const SeoChangelogPage = function (): JSX.Element {
  const { project } = useSeoProject();
  const projectId = project?.id ?? '';
  const [isReverting, setIsReverting] = useState(false);

  const {
    data: entries = [],
    isLoading,
    refetch,
  } = useSeoFetch<SeoChangelog[]>(
    ['seo-changelog', projectId],
    () => seoChangelogService.getByProject(projectId, { limit: 100 }),
    { enabled: !!projectId }
  );

  const handleRevert = useCallback(
    async (id: string) => {
      setIsReverting(true);
      try {
        await seoChangelogService.revert(id);
        refetch();
      } finally {
        setIsReverting(false);
      }
    },
    [refetch]
  );

  return (
    <SeoChangelogComponent
      entries={entries}
      isLoading={isLoading}
      onRevert={handleRevert}
      isReverting={isReverting}
    />
  );
};

export default SeoChangelogPage;
